<template>
  <div class="page--crud_view">
    <div class="inner-wrap">
      <div class="content" v-if="Object.keys(data).length>0">
        <div class="extra-component" v-if="currentSetting.extra_components && currentSetting.extra_components.editview">
          <component class="component" v-for="(component,index) in currentSetting.extra_components.editview"  :key="componentsKey[index]" :is="component"  :action="'EditView'" :data="data"></component>
        </div>
      </div>
      
      <div class="action-btn">
          <el-button @click="go(`${key}`)">{{ $t("button.back") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css';
import RelatedInfoDataTable from "@/views/crud/modules/RelatedInfoDataTable";
import { mapState } from 'vuex';

export default {
  components: {
    VueJsonPretty,
    RelatedInfoDataTable
  },
  props: {
    // namespace: String,
    // setting: {
    //   type: Array,
    //   default() {
    //     return [];
    //   }
    // },
    // data: {
    //   type: Object,
    //   default() {
    //     return {};
    //   }
    // }
  },
  async beforeMount() {
    this.key = this.$route.params.key;
    Object.assign(this.currentSetting, this.$setting.crud[this.key]);
    this.data = (await this.$axios.get(`/${this.currentSetting?.api?.view ? this.currentSetting?.api?.view : this.key}/${this.$route.params.id}`)).data;
    if(this.currentSetting?.extra_components?.editview){
      for(var i in this.currentSetting?.extra_components?.editview){
        this.componentsKey[i]=1;
      }
    }
    // var _this = this;
    // setTimeout(() => {
    //   _this.forceUpdate();
    // }, 1000);
  },
  methods: {
    forceUpdate(){
      console.log("ddd",this.componentsKey);
      for(var i in this.componentsKey){
        this.componentsKey[i]++;
      }
      this.$forceUpdate();
    },
  },
  computed: {
  },
  data() {
    return {
      key: "",
      componentsKey: {},
      currentSetting: {},
      data: {},
      params: {}
    }
  }
}
</script>

<style lang="scss">
.page--crud_view{
  // height: 90vh;
  background: white;
  border-radius: 3px;
  overflow: auto;
  & > .inner-wrap{
    padding: 10px;
    .content{
      .row{
        display: flex;
        margin-bottom: 20px;
        width: 100%;
        max-width: 100%;
        .item{
          flex-grow: 1;
          display: flex;
          width: 100%;
          font-size: x-small;
          // margin-right: 20px;
          .item__type--tab{
            flex-grow: 1;
            overflow-x: auto;
          }
          .data{
            width: 100%;
            display: flex;
          }
          .label{
            width: 130px;
            min-width: 130px;
            display: flex;
            // align-items: center;
          }
          .value{
            min-width: 200px;
            width: 100%;
            border: 1px solid gray;
            background-color: #E6E6E6 !important;
            padding: 3px 5px;
            min-height: 18px;
            height: 100%;
            display: flex;
            align-items: center;
            &.boolean{
              background-color: white!important;
              border-color: white;
              position: relative;
              & > *{
                // display: flex;
                // justify-content: flex-end;
              }
            }
            .block-layer{
              position: absolute;
              height: 100%;
              width: 100%;
              top: 0;
              left: 0;
              z-index: 1;
            }
            .json{
              .vjs-tree.is-root{
                &,.vjs-key,.vjs-value{
                  font-size: xx-small;
                }
              }
            }
          }
          &:not(:first-child) {
            margin-left: 10px;
          }
        }
      }
      .extra-component{
        margin-bottom: 20px;
      }
    }
  }
  .action{
    display: flex;
    justify-content: space-between;
  }
}
</style>